import { Injectable } from '@angular/core';
import {
    distinctUntilArrayItemChanged,
    filterNilValue,
    QueryEntity
} from '@datorama/akita';
import { MarketValuesStore, MarketValuesState } from './market-values.store';
import { map, shareReplay } from 'rxjs/operators';
import { subDays } from 'date-fns';
import { getLastWeekday, transformData } from './market-values.utils';

@Injectable({ providedIn: 'root' })
export class MarketValuesQuery extends QueryEntity<MarketValuesState> {
    constructor(protected store: MarketValuesStore) {
        super(store);
    }

    isLoading$ = this.selectLoading();
    error$ = this.selectError();

    selectChartDataForRange$(
        startDate: number,
        endDate: number,
        usePreviousEndOfDay: boolean = false
    ) {
        return this.selectAll({
            filterBy: (entity) =>
                entity.valueDate >=
                    (usePreviousEndOfDay
                        ? getLastWeekday(subDays(startDate, 1)).getTime()
                        : startDate) && entity.valueDate <= endDate
        }).pipe(
            map((marketValues) => {
                return [
                    {
                        name: 'return',
                        data: marketValues.map((item: any) => {
                            return [
                                new Date(item.valueDate).getTime(),
                                item.marketValue || null
                            ];
                        })
                    }
                ];
            })
        );
    }

    selectChartData$() {
        return this.selectAll().pipe(
            distinctUntilArrayItemChanged(),
            map((marketValues) => {
                return transformData(marketValues);
            })
        );
    }

    selectPeriodSummaryForRange$(startDate: number, endDate: number) {
        return this.selectAll({
            filterBy: (entity) =>
                entity.valueDate >= startDate && entity.valueDate <= endDate
        }).pipe(
            distinctUntilArrayItemChanged(),
            map((marketValues) => {
                return transformData(marketValues);
            })
        );
    }

    selectLastPrice$() {
        return this.selectLast().pipe(filterNilValue(), shareReplay(1));
    }
}
